import React from "react";
import { Link, Router } from "@reach/router";

interface Props {
  rootUrl: string;
  rootName: string;
}

interface CrumbProps {
  path: string;
  text: string;
}

export const Crumb: React.FC<CrumbProps> = (props) =>
  <span className="Breadcrumb">&nbsp; &gt; &nbsp;{props.text}</span>;

export const Breadcrumbs: React.FC<Props> = (props) => (
  <div className="BreadcrumbContainer">
    <div className="container max-960">
      <span className="Breadcrumb">
        <b>
          <Link to={props.rootUrl}>{props.rootName}</Link>
        </b>
      </span>

      <Router primary={false} style={{ display: "inline-block" }}>
        {props.children}
      </Router>
    </div>
  </div>
);
